const FIVERR_DOMAIN = 'fiverr.com';

module.exports = {
    FIVERR_DOMAIN,
};
